import type { EatalyBreadcrumbItem } from '@/components/eataly-breadcrumbs/index';

/** Sync breadcrumb payload from PLP/content loaders, or resolved PDP deferred payload. */
export type EatalyBreadcrumbLoaderResult = {
    items: EatalyBreadcrumbItem[];
    mergeHomeWithFirstItem: boolean;
};

/** PLP/content: sync array in loader + separate merge flag. PDP: deferred bundled result. */
export type EatalyBreadcrumbItemsLoaderValue = EatalyBreadcrumbItem[] | Promise<EatalyBreadcrumbLoaderResult>;

/** Normalized input for {@link EatalyBreadcrumbsResolver} after the hook combines sync fields. */
export type EatalyBreadcrumbResolvedInput =
    | EatalyBreadcrumbLoaderResult
    | Promise<EatalyBreadcrumbLoaderResult>
    | undefined;

export function isThenable<T>(value: unknown): value is Promise<T> {
    if (value == null || typeof value !== 'object') {
        return false;
    }
    return 'then' in value && typeof (value as Promise<unknown> & { then: unknown }).then === 'function';
}

export function toSyncBreadcrumbResult(
    items: EatalyBreadcrumbItem[],
    mergeHomeWithFirstItem = false
): EatalyBreadcrumbLoaderResult {
    return { items, mergeHomeWithFirstItem };
}
